/** Retired template revisions: a released template is immutable (accepted
 * games re-derive their game from it by id for as long as they live), so a
 * revised one ships under a NEW id and the old revision stays here as data —
 * resolvable by its id, never offered to new Creates. `released.json` pins
 * the digest of every id ever released (test/compose/templateReleases.test.ts);
 * `pnpm --filter @djgg/gameplay-kit run templates:release` keeps both files. */
import retired from './retired.json' with { type: 'json' };
import type { TemplateV1 } from './template.js';

export const RETIRED_TEMPLATES: readonly TemplateV1[] = Object.freeze(
  Object.values(retired as Record<string, TemplateV1>).map(t => Object.freeze({ ...t, retired: true as const })));
